/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import useGame from './stores/useGame.jsx'
import * as THREE from 'three'

export function ClosedDimentions(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/closed_dimentions.glb')
  const { actions } = useAnimations(animations, group)
  const showSize = useGame((state) => state.showSize)
  
  const lineMaterial = new THREE.MeshStandardMaterial()
  lineMaterial.emissive = new THREE.Color(0xffffff)
  lineMaterial.emissiveIntensity = 0.5


  console.log(actions)

  useEffect(()=>
  {
    if(showSize === true)
    { 
        actions['Cylinder.001Action'].clampWhenFinished = true
        actions['Cylinder.001Action'].loop = false
        actions['Cylinder.001Action'].paused = false
        actions['Cylinder.001Action'].repetitions = 0
        actions['Cylinder.001Action'].timeScale = 1
        actions['Cylinder.001Action'].play()
        
        actions['Cylinder.001Action.001'].clampWhenFinished = true
        actions['Cylinder.001Action.001'].loop = false
        actions['Cylinder.001Action.001'].paused = false
        actions['Cylinder.001Action.001'].repetitions = 0
        actions['Cylinder.001Action.001'].timeScale = 1
        actions['Cylinder.001Action.001'].play()
        
        actions['Cylinder.001Action.002'].clampWhenFinished = true
        actions['Cylinder.001Action.002'].loop = false
        actions['Cylinder.001Action.002'].paused = false
        actions['Cylinder.001Action.002'].repetitions = 0
        actions['Cylinder.001Action.002'].timeScale = 1
        actions['Cylinder.001Action.002'].play()
        
        actions['Cylinder.001Action.003'].clampWhenFinished = true
        actions['Cylinder.001Action.003'].loop = false
        actions['Cylinder.001Action.003'].paused = false
        actions['Cylinder.001Action.003'].repetitions = 0
        actions['Cylinder.001Action.003'].timeScale = 1
        actions['Cylinder.001Action.003'].play()

        actions['CylinderAction'].clampWhenFinished = true
        actions['CylinderAction'].loop = false
        actions['CylinderAction'].paused = false
        actions['CylinderAction'].repetitions = 0
        actions['CylinderAction'].timeScale = 1
        actions['CylinderAction'].play()

        actions['CylinderAction.002'].clampWhenFinished = true
        actions['CylinderAction.002'].loop = false
        actions['CylinderAction.002'].paused = false
        actions['CylinderAction.002'].repetitions = 0
        actions['CylinderAction.002'].timeScale = 1
        actions['CylinderAction.002'].play()

        actions['TextAction'].clampWhenFinished = true
        actions['TextAction'].loop = false
        actions['TextAction'].paused = false
        actions['TextAction'].repetitions = 0
        actions['TextAction'].timeScale = 1
        actions['TextAction'].play()

        actions['Text.001Action'].clampWhenFinished = true
        actions['Text.001Action'].loop = false
        actions['Text.001Action'].paused = false
        actions['Text.001Action'].repetitions = 0
        actions['Text.001Action'].timeScale = 1
        actions['Text.001Action'].play()

        actions['Text.001Action.001'].clampWhenFinished = true
        actions['Text.001Action.001'].loop = false
        actions['Text.001Action.001'].paused = false
        actions['Text.001Action.001'].repetitions = 0
        actions['Text.001Action.001'].timeScale = 1
        actions['Text.001Action.001'].play()

        actions['TextAction.001'].clampWhenFinished = true
        actions['TextAction.001'].loop = false
        actions['TextAction.001'].paused = false
        actions['TextAction.001'].repetitions = 0
        actions['TextAction.001'].timeScale = 1
        actions['TextAction.001'].play()

        actions['TextAction.002'].clampWhenFinished = true
        actions['TextAction.002'].loop = false
        actions['TextAction.002'].paused = false
        actions['TextAction.002'].repetitions = 0
        actions['TextAction.002'].timeScale = 1
        actions['TextAction.002'].play()

        actions['TextAction.004'].clampWhenFinished = true
        actions['TextAction.004'].loop = false
        actions['TextAction.004'].paused = false
        actions['TextAction.004'].repetitions = 0
        actions['TextAction.004'].timeScale = 1
        actions['TextAction.004'].play()

        actions['TextAction.005'].clampWhenFinished = true
        actions['TextAction.005'].loop = false
        actions['TextAction.005'].paused = false
        actions['TextAction.005'].repetitions = 0
        actions['TextAction.005'].timeScale = 1
        actions['TextAction.005'].play()

        actions['TextAction.007'].clampWhenFinished = true
        actions['TextAction.007'].loop = false
        actions['TextAction.007'].paused = false
        actions['TextAction.007'].repetitions = 0
        actions['TextAction.007'].timeScale = 1
        actions['TextAction.007'].play()

        actions['CylinderAction.001'].clampWhenFinished = true
        actions['CylinderAction.001'].loop = false
        actions['CylinderAction.001'].paused = false
        actions['CylinderAction.001'].repetitions = 0
        actions['CylinderAction.001'].timeScale = 1
        actions['CylinderAction.001'].play()

        actions['CylinderAction.003'].clampWhenFinished = true
        actions['CylinderAction.003'].loop = false
        actions['CylinderAction.003'].paused = false
        actions['CylinderAction.003'].repetitions = 0
        actions['CylinderAction.003'].timeScale = 1
        actions['CylinderAction.003'].play()

        actions['CylinderAction.004'].clampWhenFinished = true
        actions['CylinderAction.004'].loop = false
        actions['CylinderAction.004'].paused = false
        actions['CylinderAction.004'].repetitions = 0
        actions['CylinderAction.004'].timeScale = 1
        actions['CylinderAction.004'].play()

        actions['CylinderAction.005'].clampWhenFinished = true
        actions['CylinderAction.005'].loop = false
        actions['CylinderAction.005'].paused = false
        actions['CylinderAction.005'].repetitions = 0
        actions['CylinderAction.005'].timeScale = 1
        actions['CylinderAction.005'].play()

        actions['CylinderAction.006'].clampWhenFinished = true
        actions['CylinderAction.006'].loop = false
        actions['CylinderAction.006'].paused = false
        actions['CylinderAction.006'].repetitions = 0
        actions['CylinderAction.006'].timeScale = 1
        actions['CylinderAction.006'].play()

        actions['CylinderAction.007'].clampWhenFinished = true
        actions['CylinderAction.007'].loop = false
        actions['CylinderAction.007'].paused = false
        actions['CylinderAction.007'].repetitions = 0
        actions['CylinderAction.007'].timeScale = 1
        actions['CylinderAction.007'].play()
    }

    if(showSize != true)
    {
        actions['Cylinder.001Action'].clampWhenFinished = true
        actions['Cylinder.001Action'].loop = false
        actions['Cylinder.001Action'].paused = false
        actions['Cylinder.001Action'].repetitions = 0
        actions['Cylinder.001Action'].timeScale = -1
        actions['Cylinder.001Action'].play()
        
        actions['Cylinder.001Action.001'].clampWhenFinished = true
        actions['Cylinder.001Action.001'].loop = false
        actions['Cylinder.001Action.001'].paused = false
        actions['Cylinder.001Action.001'].repetitions = 0
        actions['Cylinder.001Action.001'].timeScale = -1
        actions['Cylinder.001Action.001'].play()
        
        actions['Cylinder.001Action.002'].clampWhenFinished = true
        actions['Cylinder.001Action.002'].loop = false
        actions['Cylinder.001Action.002'].paused = false
        actions['Cylinder.001Action.002'].repetitions = 0
        actions['Cylinder.001Action.002'].timeScale = -1
        actions['Cylinder.001Action.002'].play()
        
        actions['Cylinder.001Action.003'].clampWhenFinished = true
        actions['Cylinder.001Action.003'].loop = false
        actions['Cylinder.001Action.003'].paused = false
        actions['Cylinder.001Action.003'].repetitions = 0
        actions['Cylinder.001Action.003'].timeScale = -1
        actions['Cylinder.001Action.003'].play()

        actions['CylinderAction'].clampWhenFinished = true
        actions['CylinderAction'].loop = false
        actions['CylinderAction'].paused = false
        actions['CylinderAction'].repetitions = 0
        actions['CylinderAction'].timeScale = -1
        actions['CylinderAction'].play()

        actions['CylinderAction.002'].clampWhenFinished = true
        actions['CylinderAction.002'].loop = false
        actions['CylinderAction.002'].paused = false
        actions['CylinderAction.002'].repetitions = 0
        actions['CylinderAction.002'].timeScale = -1
        actions['CylinderAction.002'].play()

        actions['TextAction'].clampWhenFinished = true
        actions['TextAction'].loop = false
        actions['TextAction'].paused = false
        actions['TextAction'].repetitions = 0
        actions['TextAction'].timeScale = -1
        actions['TextAction'].play()

        actions['Text.001Action'].clampWhenFinished = true
        actions['Text.001Action'].loop = false
        actions['Text.001Action'].paused = false
        actions['Text.001Action'].repetitions = 0
        actions['Text.001Action'].timeScale = -1
        actions['Text.001Action'].play()

        actions['Text.001Action.001'].clampWhenFinished = true
        actions['Text.001Action.001'].loop = false
        actions['Text.001Action.001'].paused = false
        actions['Text.001Action.001'].repetitions = 0
        actions['Text.001Action.001'].timeScale = -1
        actions['Text.001Action.001'].play()

        actions['TextAction.001'].clampWhenFinished = true
        actions['TextAction.001'].loop = false
        actions['TextAction.001'].paused = false
        actions['TextAction.001'].repetitions = 0
        actions['TextAction.001'].timeScale = -1
        actions['TextAction.001'].play()

        actions['TextAction.002'].clampWhenFinished = true
        actions['TextAction.002'].loop = false
        actions['TextAction.002'].paused = false
        actions['TextAction.002'].repetitions = 0
        actions['TextAction.002'].timeScale = -1
        actions['TextAction.002'].play()

        actions['TextAction.004'].clampWhenFinished = true
        actions['TextAction.004'].loop = false
        actions['TextAction.004'].paused = false
        actions['TextAction.004'].repetitions = 0
        actions['TextAction.004'].timeScale = -1
        actions['TextAction.004'].play()

        actions['TextAction.005'].clampWhenFinished = true
        actions['TextAction.005'].loop = false
        actions['TextAction.005'].paused = false
        actions['TextAction.005'].repetitions = 0
        actions['TextAction.005'].timeScale = -1
        actions['TextAction.005'].play()

        actions['TextAction.007'].clampWhenFinished = true
        actions['TextAction.007'].loop = false
        actions['TextAction.007'].paused = false
        actions['TextAction.007'].repetitions = 0
        actions['TextAction.007'].timeScale = -1
        actions['TextAction.007'].play()

        actions['CylinderAction.001'].clampWhenFinished = true
        actions['CylinderAction.001'].loop = false
        actions['CylinderAction.001'].paused = false
        actions['CylinderAction.001'].repetitions = 0
        actions['CylinderAction.001'].timeScale = -1
        actions['CylinderAction.001'].play()

        actions['CylinderAction.003'].clampWhenFinished = true
        actions['CylinderAction.003'].loop = false
        actions['CylinderAction.003'].paused = false
        actions['CylinderAction.003'].repetitions = 0
        actions['CylinderAction.003'].timeScale = -1
        actions['CylinderAction.003'].play()

        actions['CylinderAction.004'].clampWhenFinished = true
        actions['CylinderAction.004'].loop = false
        actions['CylinderAction.004'].paused = false
        actions['CylinderAction.004'].repetitions = 0
        actions['CylinderAction.004'].timeScale = -1
        actions['CylinderAction.004'].play()

        actions['CylinderAction.005'].clampWhenFinished = true
        actions['CylinderAction.005'].loop = false
        actions['CylinderAction.005'].paused = false
        actions['CylinderAction.005'].repetitions = 0
        actions['CylinderAction.005'].timeScale = -1
        actions['CylinderAction.005'].play()

        actions['CylinderAction.006'].clampWhenFinished = true
        actions['CylinderAction.006'].loop = false
        actions['CylinderAction.006'].paused = false
        actions['CylinderAction.006'].repetitions = 0
        actions['CylinderAction.006'].timeScale = -1
        actions['CylinderAction.006'].play()

        actions['CylinderAction.007'].clampWhenFinished = true
        actions['CylinderAction.007'].loop = false
        actions['CylinderAction.007'].paused = false
        actions['CylinderAction.007'].repetitions = 0
        actions['CylinderAction.007'].timeScale = -1
        actions['CylinderAction.007'].play()
    }
    },[showSize])

    return (
        <group ref={group} {...props} dispose={null}>
          <group name="Scene">
            <mesh
              name="Text"
              castShadow
              receiveShadow
              geometry={nodes.Text.geometry}
              material={lineMaterial}
              position={[0.027, 0.106, -1.201]}
              scale={0}
            />
            <mesh
              name="Text001"
              castShadow
              receiveShadow
              geometry={nodes.Text001.geometry}
              material={lineMaterial}
              position={[1.936, 0.106, 0.025]}
              scale={0}
            />
            <mesh
              name="Cylinder"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder.geometry}
              material={lineMaterial}
              position={[1.792, 0.113, 0.636]}
              rotation={[-0.927, 0, 0]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Cylinder001"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder001.geometry}
              material={lineMaterial}
              position={[1.732, 0.113, 0.636]}
              rotation={[-2.034, -0.73, -1.107]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Cylinder002"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder002.geometry}
              material={lineMaterial}
              position={[1.732, 0.113, -0.546]}
              rotation={[-2.034, -0.73, -1.107]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Cylinder003"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder003.geometry}
              material={lineMaterial}
              position={[-1.342, 0.113, -1.038]}
              rotation={[-2.034, -0.73, -1.107]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Cylinder004"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder004.geometry}
              material={lineMaterial}
              position={[-1.342, 0.113, -1.098]}
              rotation={[-2.214, 0, -Math.PI]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Cylinder005"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder005.geometry}
              material={lineMaterial}
              position={[1.448, 0.113, -1.098]}
              rotation={[-2.214, 0, -Math.PI]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Text002"
              castShadow
              receiveShadow
              geometry={nodes.Text002.geometry}
              material={lineMaterial}
              position={[1.936, 0.106, 0.025]}
              scale={0}
            />
            <mesh
              name="Text003"
              castShadow
              receiveShadow
              geometry={nodes.Text003.geometry}
              material={lineMaterial}
              position={[0.027, 0.106, -1.201]}
              scale={0}
            />
            <mesh
              name="Cylinder006"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder006.geometry}
              material={lineMaterial}
              position={[0.014, 0.198, 0.562]}
              rotation={[-1.528, 1.01, 1.769]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Text004"
              castShadow
              receiveShadow
              geometry={nodes.Text004.geometry}
              material={lineMaterial}
              position={[-0.604, 1.193, 1.267]}
              scale={0}
            />
            <mesh
              name="Text005"
              castShadow
              receiveShadow
              geometry={nodes.Text005.geometry}
              material={lineMaterial}
              position={[-0.604, 1.193, 1.267]}
              scale={0}
            />
            <mesh
              name="Text006"
              castShadow
              receiveShadow
              geometry={nodes.Text006.geometry}
              material={lineMaterial}
              position={[-0.633, -0.984, 0.544]}
              scale={0}
            />
            <mesh
              name="Cylinder007"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder007.geometry}
              material={lineMaterial}
              position={[-0.334, -0.51, 0.194]}
              rotation={[0.567, 0.297, 0.716]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Cylinder008"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder008.geometry}
              material={lineMaterial}
              position={[-0.335, -0.507, 0.196]}
              rotation={[-2.323, 1.046, 2.091]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Cylinder009"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder009.geometry}
              material={lineMaterial}
              position={[-0.334, -0.51, 0.194]}
              rotation={[-1.326, 1.409, 1.24]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Cylinder010"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder010.geometry}
              material={lineMaterial}
              position={[-0.334, -0.512, 0.193]}
              rotation={[2.741, 0.816, 3.109]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Cylinder011"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder011.geometry}
              material={lineMaterial}
              position={[-0.34, -0.513, 0.195]}
              rotation={[1.672, 0.818, -2.066]}
              scale={[1, 0, 1]}
            />
            <mesh
              name="Text007"
              castShadow
              receiveShadow
              geometry={nodes.Text007.geometry}
              material={lineMaterial}
              position={[-0.633, -0.984, 0.544]}
              scale={0}
            />
          </group>
        </group>
      )
    }
    
    useGLTF.preload('/closed_dimentions.glb')